import { ColorSwatch, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ActiveTableCellPropsType = {
  isEnabled: boolean;
};

export const ActiveTableCell: React.FC<ActiveTableCellPropsType> = ({
  isEnabled,
}) => {
  const { t } = useTranslation();

  return (
    <Group gap="xs" wrap="nowrap">
      <ColorSwatch
        component="span"
        color={
          isEnabled
            ? 'var(--mantine-color-green-6)'
            : 'var(--mantine-color-yellow-5)'
        }
        size={10}
        withShadow={false}
      />
      <Text size="sm">
        {t(`REPORTS.ENUMS.ACTIVE.${isEnabled ? 'ACTIVE' : 'INACTIVE'}`)}
      </Text>
    </Group>
  );
};
